import React from 'react';
import clsx from 'clsx';
import RowElement from '../DataElements/RowElement'
import {NameTextField} from '../../../styling/Styles';

const LabelComponent = (props) => {

    const {
        deleteComponent,
        handleLabelName,
        labelName
    } = props;

    const [displayContent, setDisplayContent] = React.useState(false); 

    return(
        <div className={clsx('spacingTopDiv')}>

            <RowElement
                label='Label'
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteComponent}
            />
            <div className={clsx('spacingTopDiv', 'spacingLeftDiv','spacingRightDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>  
                <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
                    <div>
                        Label name: &nbsp;
                        <span style={{marginLeft: '4.5vw'}}>&nbsp;</span>
                        <NameTextField
                            placeholder=' Label Name'
                            onInput={e =>handleLabelName(e)}
                            value={labelName}
                        />
                    </div>
                </div>
            </div>
            <hr className={clsx('blueLine','spacingTopDiv')}/> 
        </div>
    )
}

export default LabelComponent;